import React, { Component } from 'react';
import axios from 'axios';
import { WithContext as ReactTags } from 'react-tag-input';
import appConstant from '../../../../constants/app';
import validationFunctions from '../../../utils/validations/index.js';
import validationMessages from '../../../utils/validations/messages';

const fetchTags = () => axios
  .get(`${appConstant.API_URL}/tag?access_token=${localStorage.getItem('token')}`)
  .then(res => res.data.tags.map(tag => {
    return {
      id: tag,
      text: tag,
    }
  }));

const KeyCodes = {
  comma: 188,
  enter: 13,
};

const delimiters = [
  KeyCodes.comma,
  KeyCodes.enter
];

class TagInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tags: [],
      suggestions: [],
      errorMessage: null,
    };

    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddition = this.handleAddition.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleTagClick = this.handleTagClick.bind(this);
  }

  validate = (value = this.props.value, explicitErrorMessage) => {
    if(value == null){
      this.setState({
        errorMessage: explicitErrorMessage,
      });
    }

    const {
      validationRules,
      customErrorMessage
    } = this.props;

    let valid = true;
    let errorMessage = '';
    const rules= validationRules;
    const rulesList = rules && rules.split('|');
    const customErrorMessageArr = customErrorMessage && customErrorMessage.split('|');

    let errorCounter = 0;

    rulesList && rulesList.some((ruleParam, index) => {
      if (errorCounter > 0) return false;

      const ruleSplit = ruleParam.split(':');
      const rule = ruleSplit[0];
      const parameters = (ruleSplit[1] || '').split(',');

      if (validationFunctions[rule] && !validationFunctions[rule].apply(null, [value, ...parameters])) {
        errorCounter += 1;
        errorMessage = (customErrorMessageArr && customErrorMessageArr[index]) || validationMessages[rule];
        valid = valid && false;
      }
    });

    this.setState({
      errorMessage: errorMessage,
    });

    return valid;
  }

  componentDidMount() {
    fetchTags()
      .then(res => {
        this.setState({ suggestions: res });
      })
      .catch(err => {
        console.log(err);
      })
  }

  handleDelete(i) {
    const { tags } = this.state;

    this.setState({
      tags: tags.filter((tag, index) => index !== i),
    },() => this.props.onChange(this.state.tags));
  }

  handleAddition(tag) {
   this.setState(state => ({ tags: [...state.tags, tag] }), () => this.props.onChange(this.state.tags));
  }

  handleDrag(tag, currPos, newPos) {
    const tags = [...this.state.tags];
    const newTags = tags.slice();

    newTags.splice(currPos, 1);
    newTags.splice(newPos, 0, tag);

    this.setState({ tags: newTags });
  }

  handleTagClick(index) {
    console.log('The tag at index ' + index + ' was clicked');
  }

  render() {
    const {
      tags,
      suggestions,
      errorMessage,
    } = this.state;

    return (
      <div>
        <ReactTags
          tags={tags}
          suggestions={suggestions}
          delimiters={delimiters}
          handleDelete={this.handleDelete}
          handleAddition={this.handleAddition}
          handleDrag={this.handleDrag}
          handleTagClick={this.handleTagClick}
        />
        {errorMessage && <div className="error-message">{errorMessage}</div>}
      </div>
    );
  }
}

export default TagInput;



// WEBPACK FOOTER //
// ./src/app/screens/links/newLinkForm/tagInput.js